/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type ContactDealerInlineForm_item$ref = any;
type PdpRespDealerDetailsFeedback_reviews$ref = any;
type PdpRespDealerDetailsFeedback_seller$ref = any;
type PdpRespDealerDetailsStats_reviews$ref = any;
type PdpRespDealerDetailsStats_seller$ref = any;
type PdpSharedCallDealerCta_item$ref = any;
type PdpSharedSellerTabsVariant_item$ref = any;
export type PdpRespDealerDetails_item$ref = any;
export type PdpRespDealerDetails_item = {
    readonly dealerDetailsDisplayInfo: {
        readonly ctas: {
            readonly showMakeOffer: boolean | null;
        } | null;
    } | null;
    readonly seller: {
        readonly serviceId: string | null;
        readonly trackedPhone: {
            readonly phoneNumber: string | null;
        } | null;
        readonly orderFeedbackPdp: {
            readonly " $fragmentRefs": PdpRespDealerDetailsStats_reviews$ref & PdpRespDealerDetailsFeedback_reviews$ref;
        } | null;
        readonly " $fragmentRefs": PdpRespDealerDetailsFeedback_seller$ref & PdpRespDealerDetailsStats_seller$ref;
    } | null;
    readonly " $fragmentRefs": PdpSharedCallDealerCta_item$ref & ContactDealerInlineForm_item$ref & PdpSharedSellerTabsVariant_item$ref;
    readonly " $refType": PdpRespDealerDetails_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespDealerDetails_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": "dealerDetailsDisplayInfo",
            "name": "displayInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "ItemDisplayInfo",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "ctas",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CTADisplay",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "showMakeOffer",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "seller",
            "storageKey": null,
            "args": null,
            "concreteType": "Seller",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "serviceId",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "trackedPhone",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Phone",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "phoneNumber",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "orderFeedbackPdp",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SellerOrderFeedbackPdpQueryConnection",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "PdpRespDealerDetailsStats_reviews",
                            "args": null
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "PdpRespDealerDetailsFeedback_reviews",
                            "args": null
                        }
                    ]
                },
                {
                    "kind": "FragmentSpread",
                    "name": "PdpRespDealerDetailsFeedback_seller",
                    "args": null
                },
                {
                    "kind": "FragmentSpread",
                    "name": "PdpRespDealerDetailsStats_seller",
                    "args": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedCallDealerCta_item",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "ContactDealerInlineForm_item",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedSellerTabsVariant_item",
            "args": null
        }
    ]
} as any);
(node as any).hash = '376ce87d8074fb8dc970903c99e3729d';
export default node;
